export const translationFilter = (t, keys, ...args) => {
  const res = t(keys, ...args)

  if (typeof keys === 'string' && res === keys) {
    return undefined
  }
  if (res === keys[keys.length - 1]) {
    return undefined
  }
  return res
}
